var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-btn-dialog",
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          "btn-text": "Affectation",
          width: "80vw",
          color: "primary",
          icon: "search",
          title: "Recherche"
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function() {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-2",
                    attrs: { small: "" },
                    on: { click: _vm.cancel }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.generateMessage("tech_search.cancel")) +
                        "\n    "
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      },
      "custom-btn-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c("custom-technician-selector-table", {
        attrs: {
          "entity-id": _vm.entityId,
          "property-id": _vm.propertyId,
          selection: true,
          request: _vm.request
        },
        on: { input: _vm.handleAssignClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }